import React from 'react';
import { translate } from 'react-i18next';
import { compose, hoistStatics, withState, lifecycle, withProps, defaultProps, withPropsOnChange, withHandlers } from 'recompose';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import DocumentPreview from './DocumentPreview';
import SliderArrow from '../sliderArrow/SliderArrow';
import DocumentService from '../../../services/document.service';
import WithLoading from '../../WithLoading';
import ModuleService from '../../../services/module.service';
import flh from '../../../helpers/file.helper';


const createSliderSettings = props => ({
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: <SliderArrow to="prev" />,
  nextArrow: <SliderArrow to="next" />,
  afterChange: (current) => { props.setCurrentPage(current); },
});


const createObjKeys = (count) => {
  const newImages = { 0: undefined };
  if (count) {
    for (let i = 1; i < count; i++) {
      newImages[i] = undefined;
    }
  }
  return newImages;
};

const onErrorImage = props => () => {
  props.setErrors(true);
};

const loadDocData = async (props) => {
  const { history } = props;
  const id = parseInt(props.match.params.id, 10);
  const document = await DocumentService.get(id);
  const error = typeof document !== 'object' || document.errors;
  if (!error) {
    return document;
  }
  history.push('/docs');
  return { error: true };
};

const loadPage = props => (doc_id, page) => {
  const { token } = props;
  return DocumentService.getPage({ doc_id, page, token });
};

const loadPages = props => (isStartPage) => {
  const { currentPage, activeDocument: { count_pages }, setImages, images, limit } = props;
  const newImages = {};
  const doc_id = props.match.params.id;
  if (isStartPage) {
    if (count_pages && count_pages > limit * 2) {
      for (let i = -limit; i < limit + 1; i++) {
        let page = i;
        if (i < 0) page = count_pages + i;
        newImages[page] = loadPage(props)(doc_id, page);
      }
    } else if (count_pages && count_pages !== 1) {
      for (let i = 0; i < count_pages; i++) {
        let page = i;
        if (i < 0) page = count_pages + i;
        newImages[page] = loadPage(props)(doc_id, page);
      }
    } else {
      newImages[0] = loadPage(props)(doc_id, 0);
    }
  } else {
    const cycleLimit = currentPage + limit >= count_pages ?
      count_pages : currentPage + limit + 1;
    for (let i = currentPage - limit; i < cycleLimit; i++) {
      let page = i;
      if (i < 0) page = count_pages + i;
      if (!images[page]) {
        newImages[page] = loadPage(props)(doc_id, page);
      }
    }
  }
  setImages({ ...images, ...newImages });
};

const mapStateToProps = state => ({
  token: state.auth.token,
  modulesSettings: state.modules.modulesSettings,
});

const enhance = compose(
  translate('portal'),
  connect(mapStateToProps, null),
  withState('isLoading', 'setIsLoading', true),
  withState('currentPage', 'setCurrentPage', 0),
  withState('sliderSettings', 'setSliderSettings', null),
  withState('activeDocument', 'setActiveDocument', null),
  withState('errors', 'setErrors', false),
  withState('images', 'setImages', {}),
  withState('isImage', 'setIsImage', false),
  withProps(props => ({
    sliderSettings: createSliderSettings(props),
    showComments: typeof props.showComments === 'undefined' ? true : props.showComments,
    commented: props.modulesSettings[ModuleService.TYPE_DOCUMENTS].commented,
    backgroundColor:
      props.modulesSettings[ModuleService.TYPE_DOCUMENTS].color ||
      props.modulesSettings[ModuleService.TYPE_DOCUMENTS].default_color,
    downloadLink: props.activeDocument ? flh.createDownloadLink(props.activeDocument.file_id.id, props.token) : '#',
  })),
  defaultProps({
    limit: 3,
  }),
  withPropsOnChange(['currentPage'], async (props) => {
    const { currentPage, activeDocument, images } = props;
    if (activeDocument && activeDocument.count_pages !== null && activeDocument.count_pages !== 1) {
      const { count_pages } = activeDocument;
      const nextPage = currentPage + 1 >= count_pages ? 0 : currentPage + 1;
      const prevPage = currentPage - 1 < 0 ? count_pages - 1 : currentPage - 1;
      const loadedPages = Object.keys(images).filter(i => images[i])
        .map(item => parseInt(item, 10));
      if (!loadedPages.includes(nextPage) || !loadedPages.includes(prevPage)) {
        await loadPages(props)();
      }
    }
  }),
  lifecycle({
    async componentDidMount() {
      const { setIsLoading, setActiveDocument, setImages, setIsImage, setErrors, token } = this.props;
      const item = await loadDocData(this.props);
      if (!item.error) {
        setActiveDocument(item);
        const images = createObjKeys(item.count_pages);
        setImages(images);
        setErrors(false);
        if (flh.isImage(item.file_id.filename)) {
          setIsImage(true);
          setImages({ 0: flh.createLink(item.file_id.id, token) });
        } else {
          setIsImage(false);
          loadPages({ ...this.props, activeDocument: item, images })(true);
        }
      } else {
        setErrors(true);
      }
      setIsLoading(false);
    },
    async shouldComponentUpdate(nextProps) {
      if (nextProps.match.params.id !== this.props.match.params.id) {
        const { setIsLoading, setActiveDocument, setCurrentPage, setImages, setIsImage, setErrors,token } = nextProps;
        setIsLoading(true);
        const item = await loadDocData(nextProps);
        if (!item.error) {
          setActiveDocument(item);
          const images = createObjKeys(item.count_pages);
          setImages(images);
          setErrors(false);
          if (flh.isImage(item.file_id.filename)) {
            setIsImage(true);
            setImages({ 0: flh.createLink(item.file_id.id, token) });
          } else {
            setIsImage(false);
            loadPages({ ...nextProps, activeDocument: item, images })(true);
            setCurrentPage(0);
          }
        } else {
          setErrors(true);
        }
        setIsLoading(false);
      }
    },
  }),
  withHandlers({
    onErrorImage,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(DocumentPreview)));



// WEBPACK FOOTER //
// ./src/components/modules/documentPreview/index.js